import { IAddATenantFieldProps } from '../AddATenant.types';
import { OCCUPATION_STUDENT } from '../constants/AddATenantFields.const';
import { dateValidation } from './dateValidation';

type AddATenantFieldKey = keyof IAddATenantFieldProps;

const RequiredFieldForTenants: { label: string; value: AddATenantFieldKey }[] =
  [
    { label: 'form:firstName', value: 'firstName' },
    { label: 'form:lastName', value: 'lastName' },
    { label: 'form:email', value: 'email' },
    { label: 'form:placeOfBirth', value: 'placeOfBirth' },
    { label: 'form:dateOfBirth', value: 'dateOfBirth' },
    { label: 'form:monthlyIncome', value: 'monthlyIncome' },
    { label: 'form:identification_number', value: 'identification_number' },
    { label: 'form:identification_type', value: 'identification_type' },
    { label: 'form:occupation', value: 'occupation' },
    { label: 'form:cityOfResidence', value: 'cityOfResidence' },
    { label: 'form:address', value: 'address' },
    { label: 'form:postalCode', value: 'postalCode' },
    { label: 'form:province', value: 'province' },
    { label: 'form:country', value: 'country' },
    { label: 'form:phoneNumber', value: 'phoneNumber' },
    { label: 'form:documentExpiryDate', value: 'documentExpiryDate' },
    { label: 'form:universtiy_name', value: 'universityName' },
    { label: 'form:field_of_study', value: 'fieldOfStudy' },
  ];

export const filterRequiredFieldForTenant = ({
  index,
  tenant,
}: {
  index: number;
  tenant: IAddATenantFieldProps;
}) => {
  const emptyFields = RequiredFieldForTenants.filter(field => {
    if (field.value === 'documentExpiryDate') {
      return !dateValidation(tenant[field.value]);
    }

    // Skip checking universityName and fieldOfStudy for non-students
    const isStudentField =
      field.value === 'universityName' || field.value === 'fieldOfStudy';

    if (OCCUPATION_STUDENT.includes(tenant.occupation)) {
      if (isStudentField) {
        return !tenant[field.value];
      }
    } else if (isStudentField) {
      return false;
    }

    return !tenant[field.value];
  }).map(field => field.label);

  const label =
    index === 0 ? 'documentsflow:tenant' : 'documentsflow:otherTenant';

  return {
    label,
    fields: emptyFields,
  };
};
